import styled from '@emotion/styled';

export const SadaOrgProfileSettings = styled.div``;
